//C:\VUE3\platform\src\composables\useDaumPostcode.js
// Daum(카카오) 우편번호 스크립트를 1회만 지연 로딩합니다.
// - 성공 시 이후 호출은 즉시 resolve
// - 실패 시 에러 throw
let _loaderPromise;

export function isDaumPostcodeLoaded() {
  return !!(window.daum && window.daum.Postcode);
}

export function ensureDaumPostcode() {
  if (isDaumPostcodeLoaded()) return Promise.resolve();

  if (!_loaderPromise) {
    _loaderPromise = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
      s.async = true;
      s.onload = () => resolve();
      s.onerror = () => reject(new Error('Failed to load Daum Postcode script'));
      document.head.appendChild(s);
    });
  }
  return _loaderPromise;
}
